export default "assets/images/icons/icons-a1374110.svg";